import { render, staticRenderFns } from "./CustomSelectLanguage.vue?vue&type=template&id=bb9c3694&"
import script from "./CustomSelectLanguage.vue?vue&type=script&lang=js&"
export * from "./CustomSelectLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports